import React from 'react';
import cn from 'classnames';

import styles from './message.module.scss';

export interface IMessageProps {
  children?: string;
  position: 'top' | 'bottom';
  allowOverflow?: boolean;
}

export default function Message({
  children,
  position,
  allowOverflow
}: IMessageProps) {
  const messageClass = cn(styles.message, styles[position], {
    [styles.overflow]: allowOverflow,
  });

  return (
    <div className={messageClass}>
      {children}
    </div>
  );
}
